module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-8-6e851474bd94daf6493d18be89289d34.jpg";